var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0325 0H4.96721C2.22829 0 0 2.2284 0 4.96732V13.0326C0 15.7716 2.22829 17.9999 4.96721 17.9999H13.0325C15.7716 17.9999 17.9999 15.7715 17.9999 13.0326V4.96732C18 2.2284 15.7716 0 13.0325 0ZM16.403 13.0326C16.403 14.891 14.891 16.4029 13.0326 16.4029H4.96721C3.1089 16.403 1.59704 14.891 1.59704 13.0326V4.96732C1.59704 3.10901 3.1089 1.59704 4.96721 1.59704H13.0325C14.8909 1.59704 16.4029 3.10901 16.4029 4.96732V13.0326H16.403Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99993 4.36206C6.44244 4.36206 4.36182 6.44268 4.36182 9.00018C4.36182 11.5576 6.44244 13.6381 8.99993 13.6381C11.5574 13.6381 13.6381 11.5576 13.6381 9.00018C13.6381 6.44268 11.5574 4.36206 8.99993 4.36206ZM8.99993 12.0409C7.32315 12.0409 5.95885 10.6769 5.95885 9.00007C5.95885 7.32318 7.32304 5.95899 8.99993 5.95899C10.6768 5.95899 12.041 7.32318 12.041 9.00007C12.041 10.6769 10.6767 12.0409 8.99993 12.0409Z",
    fill: "#AAAAAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8327 3.00781C13.525 3.00781 13.2227 3.13238 13.0054 3.35064C12.7871 3.56784 12.6615 3.87021 12.6615 4.17897C12.6615 4.48678 12.7872 4.78904 13.0054 5.0073C13.2226 5.2245 13.525 5.35013 13.8327 5.35013C14.1414 5.35013 14.4427 5.2245 14.661 5.0073C14.8793 4.78904 15.0038 4.48667 15.0038 4.17897C15.0038 3.87021 14.8793 3.56784 14.661 3.35064C14.4438 3.13238 14.1414 3.00781 13.8327 3.00781Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5184807b27f674e98854e43f6dce4b2a.svg";
export { ForwardRef as ReactComponent };